module.exports = __webpack_public_path__ + "media/images/icons/mail-b74386a045de5b960b8fafeec7328f9f.svg";